"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const main_schemasafe_json_1 = __importDefault(require("./main.schemasafe.json"));
exports.default = main_schemasafe_json_1.default;
